import { render, staticRenderFns } from "./NewHostTemplate.vue?vue&type=template&id=44fb1c44&scoped=true"
import script from "./NewHostTemplate.vue?vue&type=script&lang=js"
export * from "./NewHostTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewHostTemplate.vue?vue&type=style&index=0&id=44fb1c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb1c44",
  null
  
)

export default component.exports